import { Injectable ,Input, Output, EventEmitter} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, map, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserLogin } from '../models/user.login';
import { UserVendor } from '../models/user.vendor';

@Injectable({
  providedIn: 'root'
})
export class VendorService {
  //@Output() selectedVendorName: EventEmitter<any> = new EventEmitter();
  private userRoleInfo = localStorage.getItem('UserRoleInfo');
  private messageSource = new BehaviorSubject<any>(this.userRoleInfo);
  selectedVendorName = this.messageSource.asObservable();
  
  // selectedVendor(vendor: UserVendor) {    
  //   localStorage.setItem('selectedVendor', JSON.stringify(vendor));  
  //   this.selectedVendorName.emit(vendor.vendorName);
  // }


  selectedVendor(vendorName: string) {    
    this.messageSource.next(vendorName);
  }
}
